define('widgets/tournamentTracker/viewmodel',['knockout', 'underscore'], function (ko, _) {

    var setUpSubscriptions = _.once(function (activeTournamentCampaign, toggle) {
        var self = this;

        self.toggle = toggle;

        activeTournamentCampaign().currentPlayerParticipatingInCurrentTournament.subscribe(function() {
            self.toggle(true);
    })});

    function TournamentTracker(tournamentCampaigns) {

        var self = this;
        self.activeTournamentCampaign = tournamentCampaigns.activeCampaign;

        self.showTracker = TournamentTracker.prototype.showTracker;

        setUpSubscriptions(self.activeTournamentCampaign, self.showTracker);

        self.hideTracker = function(){
            self.showTracker(false);
        };

        self.activate = function(settings) {

            var self = this;

            /**
             * @var {viewmodels/tournaments/TournamentCampaignViewModel}
             */
            self.campaign = settings.campaign;

            /**
             * @var {Observable viewmodels/tournaments/TournamentViewModel}
             */
            self.trackedTournament = ko.pureComputed(function() {

                var currentTournament = self.campaign.currentTournament(),
                    previousTournament;

                if (currentTournament && currentTournament.currentPlayerOptedIn()) {
                    return currentTournament;
                }

                previousTournament = self.campaign.previousTournament();

                if (previousTournament && previousTournament.currentPlayerOptedIn()) {
                    return previousTournament;
                }

            });

        };

    };

    TournamentTracker.prototype.showTracker = ko.observable(true);


    return TournamentTracker;
});

